<template>
  <div class="send-bindemail">
    <p class="title">Email Verification</p>
    <p class="desc">
      Please verify your email so that we can send you the shipping and storage status as well as billing details about
      your items.
    </p>
    <p class="desc2">We just sent you an email with a verification code. Enter the code to continue.</p>
    <div class="input">
      <i-input v-model="email" :disabled="hasEmail" placeholder="Email" />
    </div>
    <div class="input">
      <i-input v-if="showCodeInput" v-model="code" placeholder="Verification code" />
    </div>
    <div class="input">
      <Button v-if="!showCodeInput" class="confirm-btn" :loading="loading" @click="saveEmail">
        <span>Continue</span>
      </Button>
      <Button v-else class="confirm-btn" :loading="loading" @click="bindEmail">
        <span>Confirm</span>
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '../../../components/button/Button';
import { API } from '../../../net/http';
import { mapState } from 'vuex';
export default {
  name: 'SendBindemail',
  components: {
    Button,
  },
  data() {
    return {
      code: '',
      loading: true,
      email: '',
      hasEmail: true,
      showCodeInput: false,
    };
  },
  computed: {
    ...mapState('app', ['userInfo']),
  },
  mounted() {
    this.hasEmail = this.userInfo.email.includes('@');
    if (this.hasEmail) {
      this.email = this.userInfo.email;
      this.sendCode(this.email);
      this.showCodeInput = true;
    } else {
      this.loading = false;
    }
  },
  methods: {
    sendCode(email) {
      this.loading = true;
      this.$post(API.mailSendCode, email)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$Message.success({
              content: 'The verification code has been sent to your email',
              duration: 5,
            });
            this.showCodeInput = true;
          } else {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveEmail() {
      if (this.loading) {
        return;
      }

      if (!this.showCodeInput) {
        //判断用户输入的邮箱，并将邮箱提交到服务器并发送验证码
        if (this.email.trim() === '') {
          this.$Message.error('email invalid.');
          return;
        }
        this.sendCode(this.email);
      }
    },
    bindEmail() {
      if (this.loading) {
        return;
      }
      if (this.code.trim() === '') {
        this.$Message.error('code invalid.');
        return;
      }
      this.loading = true;
      this.$post(API.mailVerifyEmail, {
        verifyCode: this.code,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$emit('bind-success');
          } else {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.send-bindemail {
  min-height: 600px;
  .title {
    .font-regular;
    font-size: 16px;
    font-weight: bold;
    color: @app-black-color;
  }
  .desc {
    .font-light;
    font-size: 12px;
    font-weight: 500;
    color: @app-black-color;
    padding-top: 20px;
  }
  .desc2 {
    .font-light;
    font-size: 12px;
    font-weight: 300;
    color: @app-black-color;
    padding-top: 36px;
  }
  .input {
    //display: flex;
    //flex-direction: row;
    //align-items: center;
    width: 400px;
    padding-top: 20px;
    .confirm-btn {
      //width: 109px;
      //margin-left: 10px;
    }
  }
}
</style>
